import { TIMELINE_LABELS, type TimelineLabel } from "../timeline/labels";
import { clampProgress } from "../timeline/progress";

export interface LegacySiteQaApi {
  setActVProgress(value: number): unknown;
  clearActVProgress?(): void;
  getState(): unknown;
}

export interface SiteQaApi extends LegacySiteQaApi {
  setProgress(value: number): unknown;
  setLabel(label: TimelineLabel | string): unknown;
  clearProgress(): void;
}

declare global {
  interface Window {
    __BB_SITE_QA__?: LegacySiteQaApi | SiteQaApi;
  }
}

export function resolveTimelineProgress(value: number | TimelineLabel | string): number {
  if (typeof value === "number") return clampProgress(value);

  if (isTimelineLabel(value)) return TIMELINE_LABELS[value];

  throw new Error(`Unknown timeline label: ${value}`);
}

export function installSiteQaApi(target: Window): SiteQaApi | null {
  const legacyApi = target.__BB_SITE_QA__;
  if (!legacyApi) return null;

  const api = legacyApi as SiteQaApi;

  api.setProgress = api.setProgress ?? ((value: number) => legacyApi.setActVProgress(resolveTimelineProgress(value)));
  api.setLabel = api.setLabel ?? ((label: TimelineLabel | string) => legacyApi.setActVProgress(resolveTimelineProgress(label)));
  api.clearProgress = api.clearProgress ?? (() => {
    legacyApi.clearActVProgress?.();
  });

  target.__BB_SITE_QA__ = api;
  return api;
}

function isTimelineLabel(value: string): value is TimelineLabel {
  return Object.prototype.hasOwnProperty.call(TIMELINE_LABELS, value);
}
